import { apiFetchJson } from './apiClient';

export interface PrivateCircleApplication {
  first_name: string;
  second_name: string;
  nickname: string;
  company?: string;
  title?: string;
  sector?: string;
  phone?: string;
}

export const privateCircleService = {
  async apply(data: PrivateCircleApplication): Promise<{ success: boolean; message: string }> {
    const result = await apiFetchJson<{ success: boolean; message: string }>(
      'POST',
      '/private-circle/applications',
      { body: data, withAuth: true },
    );
    if (!result.ok) {
      return { success: false, message: result.error };
    }
    return result.data;
  },
};
